import Api from "@/inc/Api";

export const getEduSubjectList = async () => {
    // Simulate an API call to fetch class data
    let api = Api;
    api.setUserToken();
    const response = await api.axios().get('/subject/list?all=yes&with_chapter=yes');
    return response.data.type ? response.data.data.subjects : [];
}